import React from 'react';
import {Box, Center, Text, Link} from '@chakra-ui/react';

export const FiveStandLeagueResults = () => {
  return (
    <Box mt={6}>
      <Center>
        <Text as="h3" color="#000000" fontSize={{ base: '22px' }} fontWeight="600">Five Stand League Results</Text>
      </Center>
      <Box>For current Five Stand League results, contact <Link href="mailto:competitions@goldengunclub.us">competitions@goldengunclub.us</Link></Box>
    </Box>
  );
};